<div class="msg-bubble" *ngIf="!possibleAddresses?.length || showNotFoundMessage">
  <mat-icon>announcement</mat-icon>
  <span>{{ notFoundMessage }}</span>
</div>

<div class="selected-value" *ngIf="possibleAddresses?.length && !showNotFoundMessage">
  <label *ngIf="displayAddressLabel" class="selected-value__label" i18n>Address</label>

  <iv-autocomplete
    class="address-autocomplete-field"
    fieldName="address"
    fieldId="represented-party-address-autocomplete-field"
    [fieldListOptions]="possibleAddresses"
    [fieldValue]="representedAddress"
    [fieldObjectValue]="selectedAddress"
    [fieldKeys]="{
      'label': 'address1',
      'value': 'address_seq_num',
      'custom': 'address_seq_num+address1+address2+city+postal+country',
      'separator': ', ',
      'extendSearchOn': 'address_seq_num+address1+address2+city+postal+country'
    }"
    [displayTooltip]="true"
    [isAddressAutocomplete]="true"
    [debounceTime]="0"
    placeHolderText="Search Address" placeHolderText-i18n
    [isDisabled]="disabled"
    (saveField)="addressChange({address_seq_num: $event})">
  </iv-autocomplete>

  <div class="selected-value__details address">
    <button [disabled]="true" type="button" mat-raised-button>
      <div class="address__name" *ngIf="selectedCompanyName && (selectedCompanyName).trim() !== ''">{{selectedCompanyName}}</div>
      <div class="address__line">{{selectedAddress?.address_seq_num ? selectedAddress?.address_seq_num + '. ' : '' }}{{selectedAddress?.address1 && (selectedAddress?.address1).trim() !== '' ? selectedAddress?.address1 : ''}}</div>
      <div class="address__line" *ngIf="selectedAddress?.address2 && (selectedAddress?.address2).trim() !== ''">{{selectedAddress?.address2}}</div>
      <div class="address__line" *ngIf="selectedAddress?.address3 && (selectedAddress?.address3).trim() !== ''">{{selectedAddress?.address3}}</div>
      <div class="address__line" *ngIf="selectedAddress?.address4 && (selectedAddress?.address4).trim() !== ''">{{selectedAddress?.address4}}</div>
      <div class="address__line">
        <span *ngIf="selectedAddress?.city && selectedAddress?.city?.trim() !== ''">{{selectedAddress?.city}},</span>
        <span>{{ getStateInfo(selectedAddress) }}</span>
        <span *ngIf="selectedAddress?.postal && selectedAddress?.postal?.trim() !== ''">{{selectedAddress?.postal}},</span>
        <span *ngIf="selectedAddress?.country && (selectedAddress?.country).trim() !== ''">{{selectedAddress?.country}}</span>
      </div>
      <div class="address__line" *ngIf="selectedAddress?.stx_cst_rgstn && (selectedAddress?.stx_cst_rgstn).trim() !== ''">
        GSTIN: {{selectedAddress?.stx_cst_rgstn}}
      </div>
    </button>
  </div>
</div>